<template>
  <div class="activity_ui" v-if="datas.addType == 'goods'">
    <div class="activity-box" v-for="(item, i) in finalDatas.items" @click="goGoods(item)" :style="styleBox" v-if="finalDatas.items.length>0&&item.isShow">
      <div class="activity-goods" :style="style" :class="{'shadow':datas.shadow}">
        <div class="img-box">
          <img :src="item.url+'?imageView2/1/w/234/h/312/q80/format/webp'">
        </div>
        <div class="activity-info" :style="activityInfoStyle">
          <div class="activity-name">
            {{ item.name }}
          </div>
          <div class="starList" v-if="item.star && item.star != ''" :style="starColor">
            <div class="star" v-for="(star, j) in (Math.floor(item.star))">
              <i class="iconfont iconxingxing"></i>
            </div>
            <div class="star" v-if="item.star % 1 != 0">
              <i class="iconfont iconbanxing1"></i>
            </div>
            <div class="star" v-for="(star, j) in (Math.floor(5 - item.star))">
              <i class="iconfont iconxingxing-xiantiao"></i>
            </div>
            <div class="starNum">{{ item.star }}</div>
          </div>
          <div class="activity-time" v-if="item.time">{{ item.time }}</div>
          <div class="activity-desc" v-if="item.descript">
            {{ item.descript }}
          </div>
          <div class="tagList" v-if="item.tagList && item.tagList.length > 0">
            <div class="tag" v-for="(tag, j) in item.tagList" :style="tagColor">
              {{ tag.tagName }}
            </div>
          </div>
          <div class="price" v-if="item.isShow">
            <div class="rmb">¥</div>{{item.price}}<div class="qi">起</div>
          </div>
        </div>
      </div>

    </div>

  </div>
  <div class="activity_ui" v-else>
    <div class="activity-box" v-for="(item, i) in datas.items" @click="goPage(item)" :style="styleBox">
      <div class="activity-item" :style="style">
        <div class="img-box">
          <img :src="item.url">
        </div>
        <div class="activity-info" :style="activityInfoStyle">
          <div class="activity-name">
            {{ item.name }}
          </div>
          <div class="starList" v-if="item.star && item.star != '' && item.isShowStar == 'T'" :style="starColor">
            <div class="star" v-for="(star, j) in (Math.floor(item.star))">
              <i class="iconfont iconxingxing"></i>
            </div>
            <div class="star" v-if="item.star % 1 != 0">
              <i class="iconfont iconbanxing1"></i>
            </div>
            <div class="star" v-for="(star, j) in (Math.floor(5 - item.star))">
              <i class="iconfont iconxingxing-xiantiao"></i>
            </div>
            <div class="starNum">{{ item.star }}</div>
          </div>
          <div class="activity-desc" v-if="item.desc">
            {{ item.desc }}
          </div>
          <div class="tagList" v-if="item.tagList && item.tagList.length > 0">
            <div class="tag" v-for="(tag, j) in item.tagList" :style="tagColor">
              {{ tag.name }}
            </div>
          </div>
        </div>
      </div>
      <transition name="slide-fade">
        <div class="txt-layer" v-if="item.layer">
          {{ item.link }}
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import { jAlert3 } from "@/base/jAlert/jAlert";
import api from "@/utils/api";
export default {
  props: ["datas"],
  data() {
    return {
      finalDatas: []
    };
  },
  computed: {
    style() {
      var style = ''
      if (this.datas.radius == 'circular') {
        style += `border-radius:8px;`
      }
      if (this.datas.shadow == 'shadow') {
        style += `box-shadow: 0px 6px 12px 0px rgba(74, 112, 196, 0.1);`
      }
      return style
    },
    styleBg() {
      return `background:${this.datas.bgColor};`
    },
    starColor() {
      var starColor = ''
      if (this.datas.starColor) {
        starColor += `color:${this.datas.starColor};`
      }
      return starColor
    },
    tagColor() {
      var tagsColor = ''
      if (this.datas.tagsColor) {
        tagsColor += `color:${this.datas.tagsColor};border:1px solid ${this.datas.tagsColor};`
      }
      return tagsColor
    },
    goodsTagColor() {
      var goodsTagColor = ''
      if (this.datas.tagsColor) {
        tagsColor += `color:${this.datas.tagsColor};background${this.datas.tagsColor}19;`
      }
      return tagsColor
    },
    activityInfoStyle() {
      var style = ''
      if (this.datas.shadow == 'line') {
        style += `padding-right:0;`
      }
      return style
    },
    styleBox() {
      var style = ''
      if (this.datas.shadow == 'line') {
        style += 'border-top: 1px solid #eeeeee;'
      }
      return style
    }
  },
  methods: {
    shopGoodsTemplate() {
      this.finalDatas = JSON.parse(JSON.stringify(this.datas));
      var goodsCodes = [] //门票产品
      var promiseAll = []
      this.finalDatas.items.forEach(item => {
        this.$set(item,'isShow',false)
        var goodsCodeArr = item.goodsCode.split('_')
        if (goodsCodeArr && goodsCodeArr.length > 0) {
          var goodsCode = ""
          if (goodsCodeArr.length == 1) {
            goodsCode = goodsCodeArr[0]
          } else {
            goodsCode = goodsCodeArr[goodsCodeArr.length - 2]
          }
          goodsCodes.push(goodsCode)
        }

      })
      if (goodsCodes.length > 0) {
        var obj = {
          hotelGroupCode: config.hotelGroupCode,
          clientChannel: "WECHAT",
          goodsCodes: goodsCodes,
          occDate: moment().format("YYYY-MM-DD")
        }
        if (this.user && this.user.memberId) {
          this.getCurrentCard();
          var chuzhiIndex = getStorage("cardIndex") || 0;
          obj.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
          obj.cardType = this.user.cardListDto[chuzhiIndex].cardType
        }
        promiseAll.push(api.listProductByGoodsCode(obj))

      }
      Promise.all(promiseAll).then(res => {
        var index = 0
        var noStockGoods = []
        var ticketList = []
        if (goodsCodes.length > 0) {
          if (res[index].result == 1) {
            ticketList = res[index].retVal.resultInfo
          }
          index++

        }
        this.finalDatas.items.forEach(item => {
          ticketList.forEach(goods => {
            var productCodeArr = item.goodsCode.split('_')
            if (productCodeArr && productCodeArr.length > 0) {
              var productCode = productCodeArr[productCodeArr.length - 2]
              if (productCodeArr.length == 1) {
                productCode = productCodeArr[0]
              }
              if (productCode == goods.goodsCode) {
                item.price = goods.realPrice
                item.name = goods.name
                item.isShow = true
                item.tagList = goods.tagList
                item.star = goods.commentScore
                item.productCode = goods.productCode
                item.scenicSpotCode = goods.scenicSpotCode
                item.goodsCode = item.goodsCode
                item.time = moment(goods.beginDate).format("YYYY.MM.DD") + ' - ' + moment(goods.endDate).format("YYYY.MM.DD")
                // if (goods.pictureUrl) {
                //   var pictures = goods.pictureUrl.split(';')
                //   item.url = pictures[0]
                // }

              }

            }

          })

        })
        console.log(this.finalDatas.items)
      })
    },
    goGoods(item) {
      if (this.isLogin()) {
          var distributor = ''
          if (this.$route.query.distributorId) {
              distributor = `&shareOpenid=${this.$route.query.distributorOpenIdDis}&distributorId=${this.$route.query.distributorId}&distributorOpenId=${this.$route.query.distributorOpenIdDis}`
          } else if (this.$route.query.distributorOpenIdDis) {
              distributor = `&shareOpenid=${this.$route.query.distributorOpenIdDis}`
          }
          var url = `/wechat/?/#/ticketInfo?productCode=${item.productCode}&scenicSpotCode=${item.scenicSpotCode}&goodsCode=${item.goodsCode}`
          window.location.href = `${window.location.origin}${url}${distributor}`;
      }
    },
    goPage(item) {
      if (item.link && item.link != '') {
        if (item.link.indexOf('http') != -1) {
          this.goLink(item.link)
        } else {
          this.$set(item, 'layer', true)
          setTimeout(() => {
            this.$set(item, 'layer', false)
          }, 2000)
          return;
        }

      }
    }
  },
  mounted() {
    if (this.datas.addType == 'goods') {
      this.shopGoodsTemplate()
    }

  }


};
</script>
<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.activity_ui {
  padding: 0 0.4rem;
  margin-top: -0.32rem;

  .title {
    padding: 0 0.053333rem;
    line-height: 0.586667rem;
    font-size: 16px;
    color: #1d1e2c;
  }

  .activity-box {
    position: relative;
    padding: 0.32rem 0;

    .txt-layer {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(0, 0, 0, .7);
      padding: 5px 8px;
      color: #fff;
      border-radius: 3px;
      word-break: break-all;

    }

    &:first-child {
      border-top: 0 !important;
    }

    .activity-item {
      overflow: hidden;
      display: flex;

      .img-box {
        width: 3.2rem;
        height: 2.133333rem;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .activity-info {
        position: relative;
        flex: 1;
        padding: 0 0.266667rem;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .activity-name {
          height: 0.48rem;
          line-height: 0.48rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          white-space: normal;
          overflow: hidden;
          font-size: 14px;
          word-break: break-all;
        }

      }

      .starList {
        margin-top: 0.133333rem;
        display: flex;
        color: #a3dedc;
        align-items: center;

        i {
          margin-right: 0.08rem;
          font-size: 12px;
        }

        .starNum {
          font-size: 12px;
          margin-left: 0.08rem;
        }
      }

      .activity-desc {
        margin-top: 0.106667rem;
        font-size: 12px;
        color: #999999;
        line-height: 0.48rem;
        max-height: 0.96rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        white-space: normal;
        overflow: hidden;
        word-break: break-all;
      }

      .tagList {
        display: flex;
        flex-wrap: wrap;

        .tag {
          margin-top: 5px;
          font-size: 11px;
          color: #57b1c2;
          padding: 2px;
          margin-right: 0.08rem;
          border: 1px solid #57b1c2;
        }
      }

    }

    .activity-goods {
      overflow: hidden;
      display: flex;
      &.shadow{
        .activity-info {
          .price {
            right: 10px;
            bottom: 10px;
          }
        }
        
      }
      .img-box {
        width: 3.12rem;
        height: 4.16rem;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .activity-info {
        position: relative;
        flex: 1;
        padding: 0 0.266667rem;
        display: flex;
        flex-direction: column;

        .price {

          position: absolute;
          right: 0;
          bottom: 0;
          font-family: "lvyun";
          font-size: 20px;
          color: #879FB2;
          letter-spacing: 0;
          text-align: right;
          font-weight: 400;

          .rmb {
            display: inline-block;
            font-family: "lvyun";
            font-size: 16px;
            color: #879FB2;
            letter-spacing: 0;
            font-weight: 400;
          }

          .qi {
            display: inline-block;
            font-family: SourceHanSerifCN-Medium;
            font-size: 12px;
            color: #879FB2;
            letter-spacing: 0;
            font-weight: 500;
          }
        }

        .activity-name {
          max-height: 1.066667rem;
          line-height: 0.533333rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          white-space: normal;
          overflow: hidden;
          font-size: 14px;
          word-break: break-all;
          font-family: SourceHanSerifCN-Medium;
          color: #333333;
          font-weight: bold;
        }
      }

      .starList {
        margin-top: 0.213333rem;
        display: flex;
        color: #879FB2;
        align-items: center;

        i {
          margin-right: 0.08rem;
          font-size: 12px;
        }

        .starNum {
          font-size: 12px;
          margin-left: 0.08rem;
        }
      }

      .activity-time {
        margin-top: 8px;
        font-family: SourceHanSerifCN-Regular;
        font-size: 12px;
        color: #333333;
        line-height: 12px;
        font-weight: 400;
      }

      .activity-desc {
        margin-top: 8px;
        font-family: SourceHanSerifCN-Regular;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
        line-height: 0.48rem;
        max-height: 0.96rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        white-space: normal;
        overflow: hidden;
        word-break: break-all;
      }

      .tagList {
        display: flex;
        flex-wrap: wrap;

        .tag {
          margin-top: 8px;
          font-family: SourceHanSerifCN-Regular;
          font-size: 12px;
          color: #879FB2;
          text-align: center;
          font-weight: 400;
          height: 17px;
          line-height: 17px;
          padding: 0 3px;
          background: rgba(135, 159, 178, 0.1);
          margin-right: 5px;
        }

      }

    }
    

  }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/Activity.vue